:host {
  display: block;
}

.download__details {
  opacity: 0.75;
}
